import App from '@/models/App'

export default class TrafficShipScheduleCargo extends App {
    static get entity() {
        return 'TrafficShipScheduleCargos'
    }
    static all() {
        return this.query().orderBy('createdAt', 'desc').get()
    }
    static fields() {
        return {
            id: this.attr(''),
            trafficShipScheduleId: this.attr(''),
            depPort: this.attr(''),
            destPort: this.attr(''),
            from: this.attr(''),
            to: this.attr(''),
            cargoType: this.attr(''),
            cargoAmount: this.attr(0),
        }
    }
    static apiConfig = {
        actions: {
            fetch(trafficShipScheduleId, params) {
                return this.get(
                    `traffic/ship/schedules/${trafficShipScheduleId}/cargos`,
                    {
                        params: App.get(params),
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            create(params) {
                return this.post(
                    `traffic/ship/schedules/cargos`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(trafficShipScheduleCargoId, params) {
                return this.patch(
                    `/traffic/ship/schedules/cargos/${trafficShipScheduleCargoId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(trafficShipScheduleCargoId) {
                return this.delete(
                    `traffic/ship/schedules/cargos/${trafficShipScheduleCargoId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: trafficShipScheduleCargoId,
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
